import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { isIE } from '../common/utils';

import CheckIcon from '../../img/icons/Check';
import PomlckaIcon from '../../img/icons/BBiconsPomlcka';

//use everywhere, where formik form is not present
class BbCheckbox extends React.Component {
    static propTypes = {
        value: PropTypes.bool,
        history: PropTypes.bool,
        id: PropTypes.string.isRequired,
        display: PropTypes.oneOf(["row", "column"]),
        onChange: PropTypes.func.isRequired,
        style: PropTypes.object
    };

    static defaultProps = {
        display: "row",
        style: {}
    };

    componentDidMount() {
        this.updateCheckbox(this.props.value);
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.updateCheckbox(this.props.value);
        }
    }

    updateCheckbox(value) {
        this.input.checked = value === true ? true : (value === false ? false : null);
        this.input.indeterminate = value !== true && value !== false;
    }

    render() {
        return (
            <div style={{ ...this.props.style, minWidth: this.props.label? null : isIE() ? '0px' : 'unset' }}
                className={`bb-chk-grp ${this.props.display === "row" ? "rw" : "clmn"}`}
            >
                {this.props.label && <label onClick={() => this.props.disabled ? null : this.onChange(!this.input.checked)} className="input-label">
                    {ReactHtmlParser(this.props.label)}
                </label>}
                {this.props.children && <label onClick={() => this.props.disabled ? null : this.onChange(!this.input.checked)}
                    className="input-label is-inline-flex align-items-centered"
                >
                    {this.props.children}
                </label>}
                <input ref={el => this.input = el} id={this.props.id} type="checkbox" disabled={this.props.disabled || false}
                    onChange={(e) => this.onChange(e.target.checked)} style={{position: this.props.useRelativePosition ? 'relative' : 'absolute'}}
                />
                <label className={classnames('checkbox-label', { 'checkbox-history': this.props.history })} htmlFor={this.props.id}>
                    <CheckIcon className='checked-checkbox-label' />
                    <PomlckaIcon className='indeterminate-checkbox-label' />
                </label>
            </div>
        )
    }
    onChange(value) {
        this.props.onChange(value);
    }
}

export default BbCheckbox;